export const SIDEBAR_ACCENT_CLASSNAMES = Object.freeze({
    COMPANY: {
        activeBg: "bg-tertiary-50!",
        activeText: "text-tertiary-600 md:text-text-500",
        hoverBg: "hover:bg-tertiary-30",
        hoverText: "hover:text-tertiary-600 md:hover:text-text-500",
        indicator: "bg-tertiary-600",
        iconActive: "text-tertiary-600",
        iconHover: "group-hover:text-tertiary-600",
    },
    DEFAULT: {
        activeBg: "bg-primary-50!",
        activeText: "text-primary-600 md:text-text-500",
        hoverBg: "hover:bg-primary-30",
        hoverText: "hover:text-primary-600 md:hover:text-text-500",
        indicator: "bg-primary-500",
        iconActive: "text-primary-500",
        iconHover: "group-hover:text-primary-500",
    },
} as const);
